import {get, post, securityPost} from './http'

// 登录
export const login = data => post('/user/login', data)

// 用户退出
export const logout = data => post('/user/logout', data)

// 获取用户信息
export const getUserInfo = data => get('/user/getCurrentUser', data)

// 获取媒体墙节目列表
export const getMediaWallProgram = data => post('/program/pageProgramMediaWallList', data)

// 查询媒体墙列表
export const getMediaWallList = data => post('/lightNode/mediawall/pageMediaWallNodeList', data)

// 查询媒体墙离线次数信息列表
export const getNodeLogList = data => post('/lightNode/mediawall/pageNodeLogList', data)

// 批量修改媒体墙节目是否大屏展示状态
export const batchUpdateMedialWallShowStatus = data => post('/program/batchSetProgramBigScreenPlay', data)

// 获取物联网列表
export const getTwocolorList = data => post('lightNode/twocolor/pageTwocolorNodeList', data)

// 播放节目
export const playMediaWallProgram = data => post('/program/playProgram', data)

// 获取安全客户端列表
export const queryClientList = data => securityPost('/queryClientList', data)

//向安全客户端发送指令
export const controlClient = data => securityPost('/controlClient', data)

// 获取监控列表
export const getMonitorList = data => post('/monitor/pageQueryMointorList', data)

// 批量修改监控是否大屏展示状态
export const batchSetMonitorBigScreenPlay = data => post('/monitor/batchSetMonitorBigScreenPlay', data)

// 查询楼宇
export const getBuildingList = data => post('/build/pageBuildList', data)

export const getOnlineRate = data => post('/statistic/mediawall/onlineStatistics', data)

// 获取回路管理列表
export const getSwitchLoopList = data => get('/equipment/management/getSwitchInfo', data)

// 开关控制
export const ctrlSwitch = data => post('/equipment/management/ctrlSwitch', data)

// 开关分组
export const getSwitchGroupList = data => get('/area/management/getSwitchGroup', data)

// 分组开关状态控制
export const updateSwitchStatus = data => post('/area/management/updateSwitchStatus', data)

// 分组定时任务状态控制
export const updateRegionTaskStatus = data => post('/area/management/updateTaskStatus', data)

// 获取配电柜区域分布
export const getDeviceBlock = data => get('/area/management/getAreaDistribution', data)

// 报警管理
export const getWarningList = data => get('/alarm/management/getAlarmInfo', data)

// 能耗统计
export const getEnergyStatistics = data => get('/meter/management/getTotalEnergy', data)

// 区域能耗
export const getAreaStatistics = data => get('meter/management/getAreaEnergy', data)

// 查询所有类型节点位置信息
export const getNodePositionList = data => post('/statistic/map/location', data)

// 获取配电柜在线率
export const getDeviceOnlineRate = data => get('/equipment/management/getStationOnlineRate', data)

// 获取配电柜信息
export const getStationInfo = data => get('/equipment/management/getStationInfo', data)

// 分页查询日志节点
export const getOperatorLogList = data => post('/operatorLog/pageQueryOperatorLogList', data)

// 分页查询日志节点
export const getDateOperatorLogList = data => post('/operatorLog/dateQueryOperatorLogList', data)



/*------ 配电柜 -------*/

// 配电柜列表查询
export const getRegionDeviceList = data => get('/area/management/getAllAreaStation', data)

// 获取配电柜在线率
export const getAllStationOnlineRate = data => get('/equipment/management/getAllStationOnlineRate', data)


/*------ 回路开关 -------*/

// 查看强电开关分组
export const listSwitchGroup = data => get('/strong/switch/listSwitchGroup', data)

// 查看强电开关
export const listSwitch = data => get('/strong/switch/listSwitch', data)



/*------ 能耗 -------*/

// 获取区域能耗数据
export const getLocationEnergy = data => post('/strong/energy/getLocationEnergy', data)



/*------ 强电设备控制 -------*/

// 批量关闭设备
export const batchSwitchListTurnOff = data => post('/strong/control/batchListTurnOff', data)

// 批量打开设备
export const batchSwitchListTurnOn = data => post('/strong/control/batchListTurnOn', data)



/*------ 报警信息 -------*/

// 获取报警信息
export const getStrongAlarmInfo = data => get('/alarm/management/getStrongAlarmInfo', data)

/*------ 时间轴 -------*/
// 分页查询时间轴
export const pageTimelineList = data => post('/lightTimeline/pageTimelineList', data)

// 手动操作时间轴状态
export const playTimeline = data => post('/lightTimeline/operateTimeLineStatus', data)

/*------ 融合设备 -------*/

// 分页查询融合设备节点
export const pageSmcList = data => post('/lightSmc/pageSmcList', data)

// 使融合设备节点播放预设片段
export const playFragment = data => post('/lightSmc/playFragment', data)
